import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import DemoRibbon from "@/components/site/DemoRibbon";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";

export default function SiteLayout() {
  const { pathname } = useLocation();

  // Smooth top scroll on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-white text-foreground">
      <a
        href="#main-content"
        data-testid="skip-to-main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:rounded-full focus:bg-navy focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white focus:shadow-lift"
      >
        Skip to main content
      </a>
      <DemoRibbon />
      <Nav />
      <main id="main-content" className="flex-1 pb-24 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
